import { useCallback } from 'react';
import {
  PendingEntityStatusModal,
  PendingEntityStatusModalProps,
} from 'components/PendingEntityStatusModal';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';

const usePendingEntityStatusModal = () => {
  const { openModal } = useDynamicModal();

  const open = useCallback(
    ({ entityId, targetServiceId }: PendingEntityStatusModalProps['params']) => {
      if (entityId && targetServiceId) {
        openModal({
          modal: ({ isOpen: _isOpen, toggle }) => (
            <PendingEntityStatusModal
              onClose={toggle}
              params={{
                entityId,
                targetServiceId,
              }}
              open
            />
          ),
        });
      }
    },
    [openModal],
  );

  return {
    openPendingEntityStatusModal: open,
  };
};

export default usePendingEntityStatusModal;
